import React, { useState } from 'react';
import { 
  FolderOpen, 
  Filter,
  Search,
  User
} from 'lucide-react';

import { enqueteurDashboardData } from '../../data/mockData';
import DossierCard from '../../components/Enqueteur/DossierCard';

const MesDossiers = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statutFilter, setStatutFilter] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // Combiner tous les dossiers acceptés (en cours + terminés)
  const tousLesDossiers = [
    ...enqueteurDashboardData.dossiersEnCours,
    ...enqueteurDashboardData.dossiersTermines
  ];

  // Filtrage des dossiers
  const filteredDossiers = tousLesDossiers.filter(dossier => {
    const matchesSearch = 
      dossier.numero.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dossier.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dossier.assure.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dossier.lieu.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatut = !statutFilter || dossier.statut === statutFilter;
    
    return matchesSearch && matchesStatut;
  });

  const dossiersCounts = {
    total: tousLesDossiers.length,
    enCours: enqueteurDashboardData.dossiersEnCours.length,
    termines: enqueteurDashboardData.dossiersTermines.length
  };

  return (
    <div className="animate-slide-in">
      {/* Header Mobile-First */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-port-gray-900">
              Mes Dossiers
            </h1>
            <p className="text-sm text-port-gray-600">
              Tous vos dossiers acceptés
            </p>
          </div>
        </div>

      </div>

      {/* Recherche et filtres mobile-friendly */}
      <div className="bg-white rounded-lg p-4 shadow-sm border border-port-gray-200 mb-4">
        <div className="flex flex-col space-y-3">
          {/* Barre de recherche */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-port-gray-400" />
            <input
              type="text"
              placeholder="Rechercher un dossier..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-port-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-atl-blue-500 focus:border-atl-blue-500"
            />
          </div>

          {/* Bouton filtres */}
          <div className="flex items-center justify-between">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="flex items-center px-3 py-2 bg-port-gray-100 rounded-lg text-sm"
            >
              <Filter className="h-4 w-4 mr-2" />
              Filtres
              {statutFilter && (
                <span className="ml-2 bg-atl-blue-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  1
                </span>
              )}
            </button>

            <p className="text-sm text-port-gray-600">
              {filteredDossiers.length} dossier{filteredDossiers.length > 1 ? 's' : ''}
            </p>
          </div>

          {/* Filtres étendus */}
          {showFilters && (
            <div className="pt-3 border-t border-port-gray-200">
              <label className="block text-sm font-medium text-port-gray-700 mb-2">
                Statut
              </label>
              <select
                value={statutFilter}
                onChange={(e) => setStatutFilter(e.target.value)}
                className="w-full px-3 py-2 border border-port-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-atl-blue-500 focus:border-atl-blue-500"
              >
                <option value="">Tous les statuts</option>
                <option value="en_cours">En cours</option>
                <option value="cloture">Clôturé</option>
              </select>
            </div>
          )}
        </div>
      </div>

      {/* Liste des dossiers - Format mobile-first */}
      <div className="space-y-3">
        {filteredDossiers.map(dossier => (
          <DossierCard key={dossier.id} dossier={dossier} />
        ))}
      </div>

      {/* État vide */}
      {filteredDossiers.length === 0 && (
        <div className="text-center py-12 bg-white rounded-lg border border-port-gray-200">
          <FolderOpen className="h-12 w-12 text-port-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-port-gray-900 mb-2">
            Aucun dossier trouvé
          </h3>
          <p className="text-port-gray-500">
            {searchTerm || statutFilter 
              ? 'Essayez de modifier vos critères de recherche.'
              : 'Vous n\'avez aucun dossier accepté pour le moment.'
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default MesDossiers;

